import React from 'react'

const React_Coding_Practice_20 = () => {
  return (
    <div>
      <h1>Coding Pratice 20</h1>
    </div>
  )
}

export default React_Coding_Practice_20
